export default {
    editorOnly: true,
    noTranslations: true,
    // This addon is only used on the desktop app / website, not packager.
    // The "settings" tab is provided by the host application.
    name: 'Custom accent color',
    description: 'Choose a custom accent color for the editor interface.',
    tags: ['theme'],
    credits: [
        {
            name: 'Yes shape'
        }
    ],
    dynamicDisable: true,
    userscripts: [
        {
            url: 'accent.js'
        }
    ],
    settings: [
        {
            dynamic: true,
            name: 'Accent color',
            id: 'accent-color',
            type: 'color',
            default: '#6ED561',
            allowTransparency: true
        }
    ],
    enabledByDefault: false
};
